import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconSurfaceRight.tsx
const IconSurfaceRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#d0c6c3",
			d: "m14.98 14.854-.021.146a3.04 3.04 0 0 1-.877 1.662L21 20.635l1-1.732zM9.021 14.854l.021.146c.108.643.43 1.227.877 1.662L3 20.635l-1-1.732z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#d0c6c3",
			fillRule: "evenodd",
			d: "M15 14.501a3 3 0 0 0-2-2.83l-.004-9.257h-2L11 11.196v.476a3.001 3.001 0 1 0 3.082 4.99 3.04 3.04 0 0 0 .898-1.808q.02-.173.02-.353m-4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M16.976 14.006A5 5 0 0 0 15 10.5V3.58l7 4.073v9.25z"
		})
	]
});
var IconSurfaceRight_default = forwardRef(IconSurfaceRight);
//#endregion
export { IconSurfaceRight_default as default };
